//IOS
// ionic cap sync
// ionic capacitor build ios
// ionic capacitor build ios --prod
// Build for running
// Archive
//
//Android
// ionic cap add android
// npm install capacitor-resources -g
// capacitor-resources
// ionic cap sync android
// ionic capacitor build android
// ionic capacitor build android --prod
//
export const environment = {
  // Environment Name
  env: 'DEV',

  // Is Production Environment?
  production: false,

  /// App Name/ID
  appName: 'EMPDIR',

  // App Description (full name)
  appDescription: 'Employee Directory',

  // App Version Number
  appVersion: '7.0.3',

  // App's REST Service API Root URL
  apiUrl: 'https://mobiledev.api.baystatehealth.org/empdir',

  // App's Uploaded Files Root URL
  filesUrl: 'https://dev.empdir.apps.baystatehealth.org',

  // Verlocker API URL
  verlockerUrl: 'https://mobiledev.api.baystatehealth.org/verlocker',

  // BH AppStore Deep Link URL
  appstoreUrl: 'https://mobile.baystatehealth.org/appstore/',

  // Reset password link URL
  resetPwdUrl: 'https://baystatehealth.service-now.com/nav_to.do?uri=%2F$pwd_reset.do%3Fsysparm_url%3Dpassword_reset',

  // Change password security questions link URL
  changePwdQuestionsUrl: 'https://baystatehealth.service-now.com/b_sp?id=pwd_reset_enrollment',

  // Set theme preference: user, light, dark
  // 'user' option will allow user to select theme preference (recommended).
  // 'light' and 'dark' will force their respective themes and not allow user to change.
  theme: 'user',

  // Store token in local storage to remember user?
  // Patient/Secure Apps should set this to false
  storeToken: true,

  // Allow Biometrics to login
  // This will allow users to login using biometrics (fingerprint, Touch ID or Face ID)
  allowBiometrics: false,

  // Require PIN code enabled on device
  // Patient/Secure Apps will require that the PIN code is enabled
  // If PIN is not in use, app will block user
  requirePin: false,

  // Require timeout
  // Patient/Secure Apps will require that timeout is enabled
  // On timeout, user will be bumped
  requireTimeout: false,

  // Timeout threshold
  // Determine the number of seconds when timeout will occur
  // 15 minutes = 900000
  timeoutThreshold: 900000,
};
